import * as React from 'react';
import Div from "@jumbo/shared/Div";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import MobileButton from 'app/components/MobileButton/MobileButton';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { COMMON } from 'app/utils/constants/endPoint';
import { requestApi } from 'app/utils/RestApi';
import TncViewer from '../TncViewer';


const SnK = ({ openSnK, setOpenSnk, callbackFx, params, program = "Referral Booster", showButton = true }) => {

    const descriptionElementRef = React.useRef(null);
    const [tncData, setTncData] = React.useState("");
    const [batchNo, setBatchNo] = React.useState(null);

    // State
    const [scroll, setScroll] = React.useState('paper');

    React.useEffect(() => {
        if (params && params.kode) {
            (async () => {
                const res = await requestApi(COMMON.TNC_AGENT, {
                    subfolder: "/" + params.kode
                }).then((res) => {
                    if (res?.data?.data?.tnc) {
                        setTncData(res.data.data.tnc)
                    }

                    if (res?.data?.data?.batchNo) {
                        setBatchNo(res.data.data.batchNo)
                    }
                }).catch(err => console.log(err))
            })()
        }
    }, [params]);

    if (!params) return false;

    return (
        <Dialog
            open={openSnK}
            onClose={() => setOpenSnk(false)}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{ sx: { borderRadius: '20px' } }}
        >
            <DialogTitle id="scroll-dialog-title" sx={{ backgroundColor: "#C21B17", color: "#FFFFFF", marginBottom: 0 }}>
                <Div sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={() => setOpenSnk(false)}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    Syarat dan Ketentuan {program} untuk Agen
                </Div>
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText
                    id="scroll-dialog-description"
                    ref={descriptionElementRef}
                >
                    {/* <Typography sx={{ mb: 2 }} fontSize={16} fontWeight={600} color={"black"}>Syarat & Ketententuan</Typography>
                    <Div sx={{ mb: 2 }} >
                        <div className='dis-flex' color={"black"}>
                            <div className='wording-snk1'><Typography fontSize={12}>Nama</Typography></div>
                            <div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
                            <div className='wording-snk3'><Typography fontSize={12}>{params.nama}</Typography></div>
                        </div>
                        {params.ktp &&
                            <div className='dis-flex' >
                                <div className='wording-snk1'><Typography fontSize={12}>No. KTP</Typography></div>
                                <div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
                                <div className='wording-snk3'><Typography fontSize={12}>{params.ktp}</Typography></div>
                            </div>
                        }
                        <div className='dis-flex'>
                            <div className='wording-snk1'><Typography fontSize={12}>No. AGEN</Typography></div>
                            <div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
                            <div className='wording-snk3'><Typography fontSize={12}>{params.kode}</Typography></div>
                        </div>
                    </Div> */}
                    {tncData != "" &&
                        // <div style={{color:'black'}} dangerouslySetInnerHTML={{__html: tncData.content}}></div>
                        <TncViewer content={tncData.content} batchNo={batchNo} />
                    }
                </DialogContentText>
            </DialogContent>
            {showButton &&
                <DialogActions>

                    <ButtonStyled
                        btnText={"Tidak Setuju"}
                        onClick={() => setOpenSnk(false)}
                        preset={"secondary"}
                    // disabled
                    />
                    <ButtonStyled
                        btnText={"Setuju"}
                        preset={"primary"}
                        onClick={callbackFx}
                    />
                </DialogActions>
            }
        </Dialog>
    );
};

export default SnK;